import {guest} from '@/shared/utils/routeGuards';

const Landing = () => import('@/areas/landing/views/LandingView.vue');

export const landingRoutes = {
   path: '/',
   component: Landing,
   children: [
      {
         path: '/',
         name: 'landing.home',
         component: () => import('@/areas/landing/views/LandingHomeView.vue'),
         meta: {
            title: 'Home Page',
         },
      },
      {
         path: '/support',
         name: 'landing.support',
         component: () => import('@/areas/landing/views/SupportView.vue'),
         meta: {
            title: 'Support',
         },
      },
      {
         path: '/contact',
         name: 'landing.contact',
         component: () => import('@/areas/landing/views/ContactView.vue'),
         meta: {
            title: 'Contact us!',
         },
      },
      {
         path: '/login',
         name: 'landing.login',
         children: [
            {
               path: '',
               name: 'landing.teacherLogin',
               component: () => import('@/areas/landing/views/LoginView.vue'),
               beforeEnter: guest,
               meta: {
                  title: 'Login Page',
               },
            },
            {
               // Where every identity provider sends the browser back to. The uuid says which
               // connection, so one page serves every provider a tenant has configured, and the
               // value is the redirect URI registered with that provider — it must not change.
               path: 'sso/:uuid',
               name: 'landing.ssoLogin',
               component: () => import('@/areas/landing/views/LandingHomeView.vue'),
               meta: {
                  title: 'Signing in',
               },
            },
            {
               // Where a sign-in that could not even be started lands. Almost always a
               // misconfigured connection, which the person can do nothing about.
               path: 'sso/:uuid/error',
               name: 'landing.ssoError',
               component: () => import('@/areas/landing/views/SsoErrorView.vue'),
               meta: {
                  title: 'Sign-in unavailable',
               },
            },
            {
               // The old ClassLink callback. Kept so a stale bookmark or a portal tile nobody has
               // updated yet lands somewhere that explains itself rather than on Not Found.
               path: 'classlink',
               redirect: {name: 'landing.teacherLogin'},
            },
         ],
      },
      {
         path: '/student-login',
         name: 'landing.studentLogin',
         component: () => import('@/areas/landing/views/StudentLoginView.vue'),
         beforeEnter: guest,
      },
      {
         path: '/password/email',
         name: 'landing.forgotPassword',
         component: () => import('@/areas/landing/views/PasswordResetFormView.vue'),
         beforeEnter: guest,
      },
      {
         path: '/password/reset',
         name: 'landing.resetTokenPassword',
         component: () => import('@/areas/landing/views/PasswordResetTokenView.vue'),
         beforeEnter: guest,
      },
      {
         // Every CMS page — including the former hardcoded /agreement and
         // /terms routes — resolves through this one catch-all by its path.
         path: '/:path',
         name: 'landing.page',
         component: () => import('@/areas/landing/views/PageView.vue'),
         props: true,
      },
   ],
};
